/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ProfessionalDocument = {
  properties: {
    status: {
      type: 'Enum',
      isRequired: true,
    },
    toDelete: {
      type: 'boolean',
    },
    professionDocumentConfigId: {
      type: 'string',
      isRequired: true,
    },
    files: {
      type: 'array',
      contains: {
        type: 'File',
      },
      isRequired: true,
    },
  },
} as const;
